import { WEIGHT_LABELS } from '@jane/bloom/dataAccess/constants';

export const weightLabel = (weight: string) =>
  WEIGHT_LABELS[weight]?.toLowerCase() || '';
